import type {ForestMassSpecies, ForestMassSpeciesCreate} from '@/domain/entities/ForestMassSpecies';
import type {Species} from '@/domain/entities/Species';
import type {ForestMassSpeciesRepository} from '@/domain/interfaces/ForestMassSpeciesRepository';

export class UpdateForestMassSpeciesUseCase {
  constructor(private readonly repository: ForestMassSpeciesRepository) {}
  async execute(
    forestMassUuid: string,
    species_uuids: string[],
    forestMassSpecies: ForestMassSpecies[],
    selectedSpecies: Species[],
  ) {
    const to_keep: Array<ForestMassSpecies> = [];
    const to_create: Array<ForestMassSpeciesCreate> = [];
    const to_delete = [];
    // limpiamos las seleccionadas
    for (const selected of forestMassSpecies) {
      if (species_uuids.includes(selected.speciesUuid)) {
        to_keep.push(selected);
      } else {
        to_delete.push(selected);
      }
    }
    // creamos las nuevas
    const selected_species_uuids = selectedSpecies.map(({uuid}) => uuid);
    for (const species_uuid of species_uuids) {
      if (!selected_species_uuids.includes(species_uuid)) {
        to_create.push({speciesUuid: species_uuid, forestMassUuid: forestMassUuid} as ForestMassSpeciesCreate);
      }
    }

    for (const forestMassSpecies of to_delete) {
      await this.repository.delete(forestMassSpecies.uuid);
    }

    const promises = to_create.map((forestMassSpecies) => this.repository.create(forestMassSpecies));
    const created = await Promise.all(promises);

    return [...to_keep, ...created];
  }
}
